export default {
	title: "Ticket Call",
	initialize: "Initialize all ticket number 1 calls",
	letter: "Letter",
	table: {
		guideMedium: "Guide / Medium",
		noMedium: "(no medium)",
		noGuide: "(no guide)",
	},
	noLettersAvailable: "No letters available",
	actions: {
		"queue.reset": "queue reset",
		"global.reset": "global reset",
		"ticket.reset": "ticket reset",
	},
	clearDisplay: "Clear Display",
	confirmDevReset: "Reset ALL tickets? This action cannot be undone.",
	displayDrawer: "TV Messages",
	exitFullscreen: "Exit",
	fullscreen: "Full screen",
	quickMessage: "Quick message",
	sendToDisplay: "Send to TV",
	popup: {
		status: "Status",
		calledAt: "Called at",
		call: "Call",
		finish: "Finish",
		recall: "Recall",
		reopen: "Reopen",
		reset: "Reset",
		cancelledAt: "Cancelled at",
		confirmReset: "Confirm reset of this ticket?",
		consultant: "Consultant",
		finishedAt: "Finished at",
		totalTime: "Total time",
	},
	errors: {
		generic: "An error occurred",
		initialize: "Error initializing calls",
		next: "Error calling next ticket",
		loadRitual: "Error loading ritual",
		ritualNotInProgress: "This ritual is not in progress. Only open rituals allow ticket calls.",
	},
	messages: {
		called: "Ticket called successfully",
		finished: "Ticket finished successfully",
		globalResetDone: "Global reset completed",
		initialized: "Tickets initialized successfully",
		recalled: "Ticket recalled",
		reconnected: "Connection reestablished",
		reopened: "Ticket reopened successfully",
		resetDone: "Ticket reset",
	},
	stats: {
		called: "In service",
		completed: "Finished",
		pending: "Pending",
	},
	devReset: "Dev Reset",
};
